import axiosApi from '@/api/axiosApi';

// 保存售前咨询表单信息
export const preSalesSave = (data) => axiosApi({
  method: 'POST',
  url: '/intserv/preSales/save',
  data,
});

